/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CompanyAttributesProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create one or multiple new company attribute definitions
   * @param requestBody
   * @returns any Successfully created company attribute(s)
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesMcpCompanyAttributes(
    requestBody: {
      /**
       * Display label for the company attribute.
       */
      label: string;
      /**
       * Key identifying the company attribute.
       */
      key?: string;
      /**
       * Data type of the attribute.
       */
      dataType: 'string' | 'number' | 'date' | 'boolean';
      /**
       * Description of the company attribute.
       */
      description?: string;
      /**
       * Whether the attribute is read-only.
       */
      readOnly?: boolean;
      /**
       * Options for the company attribute.
       */
      options?: Array<{
        value: string;
        label: string;
      }>;
      /**
       * Hire UUID for the company attribute.
       */
      hireUuid?: string;
      /**
       * Model this attribute is attached to.
       */
      attachedToModel: 'location' | 'locationGroup' | 'job' | 'opening';
    },
  ): CancelablePromise<{
    uuid?: string;
    readonly createdAt?: string;
    readonly createdBy?: string;
    readonly lastUpdatedAt?: string;
    readonly lastUpdatedBy?: string;
    readonly lastUpdatedByAudience?: string;
    readonly lastUpdatedByAudienceUuid?: string;
    readonly lastUpdatedByImpersonatedBy?: string;
    readonly lastUpdatedByCompanyUuid?: string;
    readonly lastUpdatedByEnterpriseUuid?: string;
    label: string;
    key?: string;
    dataType: 'string' | 'number' | 'date' | 'boolean' | 'select' | 'address' | 'media' | 'signature' | 'complianceDocument';
    description?: string;
    options?: Array<{
      value: string;
      label?: string;
    }>;
    hireUuid?: string;
    readOnly?: boolean;
    attachedToModel?: 'location' | 'locationGroup' | 'job' | 'opening';
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/mcp/companyAttributes',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `default error response`,
        500: `default error response`,
      },
    });
  }

  /**
   * Update one or multiple existing company attribute definitions
   * @param requestBody
   * @returns any Successfully updated company attribute(s)
   * @throws ApiError
   */
  public patchApiServiceorganizationsProcessesMcpCompanyAttributes(
    requestBody: {
      /**
       * Display label for the company attribute.
       */
      label?: string;
      /**
       * Key identifying the company attribute.
       */
      key?: string;
      /**
       * Data type of the attribute.
       */
      dataType?: 'string' | 'number' | 'date' | 'boolean';
      /**
       * Description of the company attribute.
       */
      description?: string;
      /**
       * Options for the company attribute.
       */
      options?: Array<{
        value: string;
        label: string;
      }>;
      /**
       * Hire UUID for the company attribute.
       */
      hireUuid?: string;
      /**
       * Model this attribute is attached to.
       */
      attachedToModel?: 'location' | 'locationGroup' | 'job' | 'opening';
      /**
       * Unique identifier for the company attribute.
       */
      uuid?: string;
    },
  ): CancelablePromise<{
    uuid?: string;
    readonly createdAt?: string;
    readonly createdBy?: string;
    readonly lastUpdatedAt?: string;
    readonly lastUpdatedBy?: string;
    readonly lastUpdatedByAudience?: string;
    readonly lastUpdatedByAudienceUuid?: string;
    readonly lastUpdatedByImpersonatedBy?: string;
    readonly lastUpdatedByCompanyUuid?: string;
    readonly lastUpdatedByEnterpriseUuid?: string;
    label: string;
    key?: string;
    dataType: 'string' | 'number' | 'date' | 'boolean' | 'select' | 'address' | 'media' | 'signature' | 'complianceDocument';
    description?: string;
    options?: Array<{
      value: string;
      label?: string;
    }>;
    hireUuid?: string;
    readOnly?: boolean;
    attachedToModel?: 'location' | 'locationGroup' | 'job' | 'opening';
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/serviceorganizations/processes/mcp/companyAttributes',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `default error response`,
        500: `default error response`,
      },
    });
  }

  /**
   * Upsert an existing company attribute definition by key
   * @param requestBody
   * @returns any Successfully upserted company attribute
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesCompanyAttributesUpsert(
    requestBody: {
      /**
       * Display label for the company attribute.
       */
      label: string;
      /**
       * Key identifying the company attribute.
       */
      key?: string;
      /**
       * Data type of the attribute.
       */
      dataType: 'string' | 'number' | 'date' | 'boolean';
      /**
       * Description of the company attribute.
       */
      description?: string;
      /**
       * Whether the attribute is read-only.
       */
      readOnly?: boolean;
      /**
       * Options for the company attribute.
       */
      options?: Array<{
        value: string;
        label: string;
      }>;
      /**
       * Hire UUID for the company attribute.
       */
      hireUuid?: string;
      /**
       * Model this attribute is attached to.
       */
      attachedToModel: 'location' | 'locationGroup' | 'job' | 'opening';
    },
  ): CancelablePromise<{
    uuid?: string;
    readonly createdAt?: string;
    readonly createdBy?: string;
    readonly lastUpdatedAt?: string;
    readonly lastUpdatedBy?: string;
    readonly lastUpdatedByAudience?: string;
    readonly lastUpdatedByAudienceUuid?: string;
    readonly lastUpdatedByImpersonatedBy?: string;
    readonly lastUpdatedByCompanyUuid?: string;
    readonly lastUpdatedByEnterpriseUuid?: string;
    label: string;
    key?: string;
    dataType: 'string' | 'number' | 'date' | 'boolean' | 'select' | 'address' | 'media' | 'signature' | 'complianceDocument';
    description?: string;
    options?: Array<{
      value: string;
      label?: string;
    }>;
    hireUuid?: string;
    readOnly?: boolean;
    attachedToModel?: 'location' | 'locationGroup' | 'job' | 'opening';
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/companyAttributes/upsert',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `default error response`,
        500: `default error response`,
      },
    });
  }

}
